import {
  Component,
  forwardRef,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { FinancialServiceOpenQuoteWrapper } from '@app/pages/quote/open-quote/financial-service/financial-service-wrapper.component';

@Component({
  selector: 'app-financial-service-mobile',
  templateUrl: './financial-service-mobile.component.html',
  styleUrls: ['./financial-service-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinancialServiceMobileComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FinancialServiceMobileComponent),
      multi: true,
    },
  ],
})
export class FinancialServiceMobileComponent extends FinancialServiceOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
